import { jsx as _jsx } from "react/jsx-runtime";
import { AnnotationOutline } from "@air/next-icons";
import { formatDuration } from "@air/utilities";
import isUndefined from "lodash/isUndefined";
import { memo, useMemo } from "react";
import { getPageNumber, isAnnotationCorrect } from "~/components/Annotations/shared/annotationUtils";
import { DiscussionMetadata } from "~/components/Discussions/Discussion/DiscussionComment/components/DiscussionMetadata";
import { ANNOTATION_PAGE_NUMBER, DISCUSSION_HEADER_TIMESTAMP_PILL } from "~/constants/testIDs";
export const DiscussionAnnotationInfo = /*#__PURE__*/ memo((param)=>{
    let { discussion: { annotation }, color } = param;
    const timestamp = annotation === null || annotation === void 0 ? void 0 : annotation.timestamp;
    const pageNumber = getPageNumber(annotation);
    const textInfo = useMemo(()=>{
        if (!isUndefined(timestamp)) {
            return {
                info: formatDuration(Math.round(timestamp)),
                textTestId: DISCUSSION_HEADER_TIMESTAMP_PILL
            };
        } else if (!isUndefined(pageNumber) && pageNumber !== -1) {
            return {
                info: "pg.".concat(pageNumber),
                textTestId: ANNOTATION_PAGE_NUMBER
            };
        }
    }, [
        pageNumber,
        timestamp
    ]);
    if (!isAnnotationCorrect(annotation)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(DiscussionMetadata, {
        Icon: AnnotationOutline,
        text: textInfo === null || textInfo === void 0 ? void 0 : textInfo.info,
        color: color,
        textTestId: textInfo === null || textInfo === void 0 ? void 0 : textInfo.textTestId
    });
});
DiscussionAnnotationInfo.displayName = "DiscussionAnnotationInfo";
